<div class="stp-modal">

  <swiper [slidesPerView]="1" [spaceBetween]="0" [navigation]="true" [pagination]="{ clickable: false }"
    [scrollbar]="{ draggable: false }" class="carousel-container" (slideChange)="onSlideChange($event)" #swiper>

    <ng-template swiperSlide>
      <div class="w-75 text-center mx-auto mb-5">
        <img class="info-circle mb-4 img-fluid" src="https://static.monific.com/assets/assets-app/img/icon/img/stp_3.svg" alt="">
        <p class="fs-17 cl-primary mb-4">
          Con tu <strong>MoNIP</strong> podrás realizar tus inversiones de forma rápida y segura</p>
        <button mat-button (click)="slideTo(1)">Aceptar</button>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="w-75 w-md-50 mx-auto text-center cl-primary mb-4 mt-5 pt-5"
        [ngClass]="this.activeIndex === 1 ? 'd-block' : 'd-none'">
        <p class="fs-17 fw-sbold">Crea tu MoNIP</p>
        <ng-otp-input (onInputChange)="checkNip($event)" [config]="otpInputConfig" id="nip" #nipInput></ng-otp-input>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="w-75 w-md-50 mx-auto text-center cl-primary mb-4 mt-5 pt-5"
        [ngClass]="this.activeIndex === 2 ? 'd-block' : 'd-none'">
        <p class="fs-17 fw-sbold">Confirma tu MoNIP</p>
        <ng-otp-input (onInputChange)="checkConfirmNip($event)" [config]="otpInputConfig" id="confirm-nip" #confirmNipInput>
        </ng-otp-input>
      </div>
    </ng-template>

  </swiper>

</div>
